/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-14 09:38:09
 */
import React, { FC } from "react";

interface CardProps {
  name?: string;
  subtitle?: {
    name: string;
    number: number | string;
  }[];
}

export const Card: FC<CardProps> = (props) => {
  const { name, subtitle } = props;

  return (
    <div className="summarize-card">
      <h3 className="summarize-card-title">{name}</h3>
      <ul className="summarize-card-container">
        {subtitle?.map((item, index) => {
          return (
            <li key={index}>
              <p>{item.name}</p>
              <p>{item.number}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
